import { Container, Grid, Paper } from '@mui/material';
import React, { useEffect } from 'react';
import MyCustomImageUploader from '../../components/imageInput/MyCustomImageUploader';
import {
  CategoryTranslationInput,
  TranslationInput,
} from '../../config/types/custom/TranslationInput';
import { useAwsUpload } from '../../dataProviders/useAwsUpload';
import {
  useCategoryDetails,
  useSaveCategory,
} from '../../hooks/category/useCategory';
import CategoryNames from './category/CategoryNames';
import { useLanguages } from '../../hooks/product/useLangauges';
import CategoryDescription from './category/CategoryDescriptions';
import CategoryBar from './category/CategoryBar';
import { useNotify, useTranslate } from 'react-admin';
import { useParams } from 'react-router';

function CategoryChange() {
  const { id } = useParams();
  const [image, setImage] = React.useState<string>('');
  const [slug, setSlug] = React.useState<string>('');
  const [name, setName] = React.useState<string>('');
  const [description, setDescription] = React.useState<string>('');
  const [isActive, setIsActive] = React.useState<boolean>(false);
  const [translations, setTranslations] = React.useState<
    CategoryTranslationInput[]
  >([]);

  const { data: langauges, isLoading: loadingLanguages } = useLanguages();

  const [dbImage, setDbImage] = React.useState<string>('');
  const { loading, upload } = useAwsUpload();

  const t = useTranslate();
  const notify = useNotify();
  const { data: currentCategory, isLoading } = useCategoryDetails(id);
  const saveMutation = useSaveCategory();

  const onChangeImage = async (f: File[], b: string[]) => {
    if (f.length > 0) {
      const newImageUrl = await upload(f[0]);
      setImage(newImageUrl);
    } else {
      setImage(dbImage);
    }
  };

  const onSaveCategory = () => {
    saveMutation.mutate(
      {
        id: id ? parseInt(id) : null,
        name,
        slug,
        description,
        isActive,
        translations,
        image,
      },
      {
        onSuccess: () => {
          notify(t('categorySaved'));
        },
      }
    );
  };

  useEffect(() => {
    if (currentCategory) {
      setImage(currentCategory.image);
      setSlug(currentCategory.slug);
      setName(currentCategory.name);
      setDescription(currentCategory.description);
      setIsActive(currentCategory.isActive);
      setTranslations(currentCategory.translations);
      setDbImage(currentCategory.image);
    }
  }, [currentCategory]);

  return (
    <Container>
      <CategoryBar
        onSave={onSaveCategory}
        isActive={isActive}
        setIsActive={setIsActive}
      />
      <Grid container>
        <Grid sx={{ padding: 2 }} item xs={12} md={6}>
          <Paper sx={{ padding: 2, height: 'calc(100% - 30px)' }}>
            <MyCustomImageUploader
              single={true}
              onChange={onChangeImage}
              image={image}
            />
          </Paper>
        </Grid>

        <Grid sx={{ padding: 2 }} item xs={12} md={6}>
          <Paper sx={{ padding: 2, height: 'calc(100% - 30px)' }}>
            <CategoryNames
              id={id}
              slug={slug}
              name={name}
              setSlug={setSlug}
              translations={translations}
              languages={langauges}
              setName={setName}
              setTranslations={setTranslations}
            />
          </Paper>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Paper sx={{ padding: 2, height: 'calc(100% - 30px)' }}>
            <CategoryDescription
              description={description}
              setDescription={setDescription}
              translations={translations}
              setTranslations={setTranslations}
              languages={langauges}
            />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default CategoryChange;
